import script from "./ChatAccessBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatAccessBanner.vue?vue&type=script&setup=true&lang=js"

import "./ChatAccessBanner.vue?vue&type=style&index=0&id=088ac7e2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-088ac7e2"]])

export default __exports__